<script lang="ts">
	export let link: string;
	export let image: string;
    export let title: string;
    export let alt: string;
</script>

<div class="supplier-box">
	<div class="supplier-img">
		<a href="{link}" target="_blank" rel="noopener noreferrer"><img class="img-responsive" src={image} alt="{alt}" title="{title}" /></a>
	</div>
</div>

<style lang="scss">
	.supplier-img img {
		height: 175px;
		object-fit: contain;
	}
</style>
